import React from 'react';

import HomeTitle from '../components/home-title';
import Layout from '../components/layout';
import SEO from '../components/seo';
import Slider from '../components/slider/';
import HomeCta from '../components/home-cta';


class IndexPage extends React.Component<{}, {}> {

  trackingLoaded = false;
  trackingTry = 20;

  sendTracking() {
    if (this.trackingTry <= 0) {
      return;
    }

    const isTrackingActive = typeof window !== 'undefined' && typeof window.tC !== 'undefined';

    if (!this.trackingLoaded && !isTrackingActive) {
      this.trackingTry--;

      if (this.trackingTry <= 0) {
        return;
      }

      return setTimeout(this.sendTracking, 200);
    }

    this.trackingLoaded = true;

    setTimeout(() => {
      if ( typeof window !== 'undefined' && typeof window.tC !== 'undefined' ) {
          window.tc_vars.pagename = document.title;
          window.tC.container.reload();
          window.tC.event.pageview(window,{});
      }
    }, 100);
  }

  componentDidMount() {
    this.sendTracking();
  }

  render() {
    return (
      <Layout>
        <SEO
          bodyClass="home"
          facebook="/social/facebook/home.jpg"
          slug=""
          twitter="/social/twitter/home.jpg"
          title="Home"
        />
        <HomeTitle />
        <Slider />
        <HomeCta />
      </Layout>
    );
  }
}

export default IndexPage;
